import { Auth0Provider } from '@auth0/auth0-react';
import { ErrorsProvider } from 'components/app/error';
import 'helpers/initFA';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { getThemeKey } from 'shared/utils/getDomainAndSubdomain';
import store from 'store';
import App from './App';
import Main from './Main';

export const subdomainMap = {
  duckenergy: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_DUCKENERGY ?? ''
  },
  amityage: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_AMITYAGE ?? ''
  },
  'cryptohall24-duerr': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CRYPTOHALL_DUERR ?? ''
  },
  'cryptohall24-quetta': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CRYPTOHALL_QUETTA ?? ''
  },
  qurubiqa: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_QURUBIQA ?? ''
  },
  bitcluster: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_BITCLUSTER ?? ''
  },
  paymine: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_PAYMINE ?? ''
  },
  dahab: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_DAHAB ?? ''
  },
  bmw: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_BMW ?? ''
  },
  'stellar-forge': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_STELLAR_FORGE ?? ''
  },
  pantheon: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_PANTHEON ?? ''
  },
  'pantheon-aus': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_PANTHEON_AUS ?? ''
  },
  avatron: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_AVATRON ?? ''
  },
  polarcore: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_POLARCORE ?? ''
  },
  endlessmining: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_ENDLESSMINING ?? ''
  },
  sabre56: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_SABRE56 ?? ''
  },
  'chronos-energy': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CHRONOS_ENERGY ?? ''
  },
  higgs: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_HIGGS ?? ''
  },
  mawson: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_MAWSON ?? ''
  },
  'revolve-labs': {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_REVOLVE_LABS ?? ''
  },
  hearst: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_HEARST ?? ''
  },
  datacubes: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_DATACUBES ?? ''
  },
  bitasics: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_BITASICS ?? ''
  },
  emcd: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_EMCD ?? ''
  },
  blueforge: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_BLUEFORGE ?? ''
  },
  cryptotech: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CRYPTOTECH ?? ''
  },
  miningstore: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_MININGSTORE ?? ''
  },
  hashlabs: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_HASHLABS ?? ''
  },
  corpa: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CORPA ?? ''
  },
  terahash: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_TERAHASH ?? ''
  },
  fortris: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_FORTRIS ?? ''
  },
  ymir: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_YMIR ?? ''
  },
  chazon: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_CHAZON ?? ''
  },
  miningwithbrad: {
    orgId: process.env.REACT_APP_AUTH0_ORG_ID_MININGWITHBRAD ?? ''
  }
};

const container = document.getElementById('main');
const root = createRoot(container);

const initializeApp = async () => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const { themeKey } = getThemeKey();
  const clientInfo = themeKey ? subdomainMap[themeKey.toLowerCase()] : null;

  const authorizationParams = {
    redirect_uri: window.location.origin,
    organization: clientInfo?.orgId,
    audience,
    scope: 'profile openid email'
  };

  const onRedirectCallback = appState => {
    window.history.replaceState(
      {},
      document.title,
      appState?.targetUrl ?? `${window.location.origin}/dashboard`
    );
  };

  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={authorizationParams}
        onRedirectCallback={onRedirectCallback}
      >
        <Provider store={store}>
          <ErrorsProvider>
            <Main>
              <App />
            </Main>
          </ErrorsProvider>
        </Provider>
      </Auth0Provider>
    </React.StrictMode>
  );
};

initializeApp();
initializeApp();
